// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "template-assets/css/" + chunkId + "." + {"581": "bbc1e9da","667": "bb44b879","674": "2f8973b8",}[chunkId] + ".css"
}